import { routerApp, baseUrl, enableOnPremise } from '../app.module';
import angular from 'angular';
import { httpRequestGenerator } from './utilities';

routerApp.factory('FuelSpecService', ['$http', '$log', function($http: angular.IHttpService, $log: angular.ILogService) {
    var requestFunc = httpRequestGenerator(enableOnPremise, $http);
    var defaultFuelSpecs = null
    return {
        getDefaultFuelSpecs: () => {
            if (defaultFuelSpecs) {
                return Promise.resolve(defaultFuelSpecs);
            }

            return requestFunc({
                url: `${baseUrl}v2/fuel_specifications/default`,
                method: 'GET'
            }).then((response: any) => {
                defaultFuelSpecs = response.data.data;
                return defaultFuelSpecs;
            });
        },
        getDefaultFuelSpec: (fuelSpecId: string) => {
            return requestFunc({
                url: `${baseUrl}v2/fuel_specifications/default/${fuelSpecId}`,
                method: 'GET'
            });
        },
    }
}]);